import './styles.scss';

export const OutletLabel = ({ label }: any) => {
  return <span className="outlet-label">{label}</span>;
};
